import { render, staticRenderFns } from "./MemberLevelSettingStep2ServiceAddition.vue?vue&type=template&id=a8b52b22&"
import script from "./MemberLevelSettingStep2ServiceAddition.vue?vue&type=script&lang=js&"
export * from "./MemberLevelSettingStep2ServiceAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports